<!-- Resend Code Timer Alert Red -->
<div class="row">
  <div class="col-md-12" [hidden]="!showResendCodeAlert">
    <ngb-alert type="danger" [dismissible]="false">
      A security code was recently sent. Please wait
      {{ (resendCodeTimer$ | async) || 30 }} seconds before trying again.
    </ngb-alert>
  </div>
</div>

<!-- Resend Code Timer Alert Green -->
<div class="row">
  <div class="col-md-12" [hidden]="!showResendCodeSuccessAlert">
    <ngb-alert type="success" [dismissible]="false">
      A security code was successfully sent. Please wait
      {{ (resendCodeTimer$ | async) || 30 }} seconds before trying again.
    </ngb-alert>
  </div>
</div>

<!-- Select MFA Type and Send Code View -->

<div *ngIf="!isCodeSent && !repromptUsernamePwd">
  <h1 class="harp-card-title">Two-Factor Authentication</h1>
  <p>Select a device to verify your account.</p>

  <form [formGroup]="mfaSelectForm">
    <harp-input [inputConfig]="mfaSelectInputConfig"></harp-input>
  </form>

  <!-- Send Code Button -->
  <button
    type="button"
    class="btn btn-primary btn-lg"
    [disabled]="
      mfaSelectForm.invalid || isSendCodeDisabled || this.isMfaDisabled
    "
    (click)="userFactorCheck($event)"
    [value]="buttonText"
  >
    {{ buttonText }}
  </button>

  <!-- Cancel Button -->
  <button
    [routerLink]="['/login']"
    queryParamsHandling="merge"
    type="button"
    class="btn btn-link btn-lg"
    [disabled]="isMfaDisabled"
  >
    Cancel
  </button>

  <!-- Terms and Conditions Button -->
  <div *ngIf="showPhoneModalLinks()" class="mt-4">
    <button class="link" (click)="openModal(termsAndConditions)">
      Terms and Conditions
    </button>
  </div>

  <!-- Privacy Policy Button -->
  <div *ngIf="showPhoneModalLinks()" class="mt-4">
    <button class="link" (click)="openModal(privacyPolicy)">
      Privacy Policy
    </button>
  </div>
</div>

<!-- Reprompt Username and Password for Okta Verify Push Scenario-->
<div *ngIf="repromptUsernamePwd">
  <h1 class="harp-card-title">Two-Factor Authentication</h1>

  <p>
    You must resubmit your username and password before updating your MFA
    devices because the Okta Verify Push notification has already been sent.
  </p>
  <form [formGroup]="basicAuthForm">
    <harp-input [inputConfig]="userIdConfig"></harp-input>
    <harp-input [inputConfig]="passwordConfig"></harp-input>

    <!-- Cancel Button -->
    <button
      [routerLink]="['/login']"
      queryParamsHandling="merge"
      type="button"
      class="btn btn-link btn-lg"
    >
      Cancel
    </button>

    <!-- Re-Login Button -->
    <button
      class="btn btn-primary btn-lg"
      (click)="resubmitBasicAuth()"
      [disabled]="!basicAuthForm.valid"
    >
      Continue
    </button>
  </form>
</div>

<!-- Enter Security Code View -->
<div *ngIf="isCodeSent">
  <h1 class="harp-card-title">Enter Code</h1>
  <p>Enter the security code to verify your account.</p>

  <form
    [formGroup]="otpFormConfig"
    (ngSubmit)="otpFormConfig.valid && sendCodeCheck()"
  >
    <harp-input [inputConfig]="otpInputConfig"></harp-input>
  </form>

  <button
    class="btn btn-primary btn-lg"
    [disabled]="!otpFormConfig.valid"
    (click)="sendCodeCheck()"
  >
    Submit
  </button>
  <button
    [routerLink]="['/login']"
    queryParamsHandling="merge"
    type="button"
    class="btn btn-link btn-lg"
  >
    Cancel
  </button>

  <!-- Resend Code Button -->
  <p class="mt-4" *ngIf="isTextOrCall">
    Need a new code?
    <button
      (click)="resendCode()"
      [disabled]="isResendDisabled"
      class="link"
      type="button"
    >
      Resend Code
    </button>
  </p>
</div>

<ng-template #termsAndConditions let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modalTitle">
      IDM SMS & Voice Terms and Conditions
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d()"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      By enabling SMS or Voice Multi-Factor Authentication (MFA), you agree to
      the following terms and conditions. This service adds an extra layer of
      security to your account, helping to protect your personal information
      from unauthorized access.
    </p>
    <strong>Service Description</strong>
    <p>
      The Centers for Medicare & Medicaid Services (CMS) provides this service
      to enhance the security of your account by delivering OTPs via SMS or
      Voice calls to your registered mobile number.
    </p>
    <p>
      • The accurate delivery of OTPs depends on the correct entry of your
      mobile phone number.
    </p>
    <strong>Enrollment and Double Opt-In</strong>
    <p>During enrollment provide a valid mobile phone number.</p>
    <p>
      • A confirmation request (via SMS or Voice) will verify your mobile
      number.
    </p>
    <p>
      Enrollment completes only after you confirm your intent to receive OTPs by
      responding to the confirmation request (double opt-in).
    </p>
    <strong>User Responsibilities</strong>
    <p>Maintain an up-to-date mobile number.</p>
    <p>
      Ensure only you have access to your mobile device. Do not share
      authentication codes with anyone.
    </p>
    <p>
      • Promptly update your contact information if your mobile number changes
      to maintain uninterrupted access.
    </p>
    <strong>Service Limitations</strong>
    <p>
      Delivery of SMS and voice messages may experience delays or failures due
      to network issues beyond CMS' control.
    </p>
    <p>
      CMS is not responsible for any cost associated with receiving SMS or voice
      messages; such costs are the responsibility of the user.
    </p>
    <strong>Opt-Out</strong>
    <p>
      You may opt-out of receiving OTPs at any time by contacting CMS support or
      following opt-out instructions provided during enrollment.
    </p>
    <p>Opting out may affect your ability to securely access CMS system.</p>
    <strong>Privacy and Data Security</strong>
    <p>
      Your mobile number and data collected during the MFA process are used
      solely for authentication purposes and to enhance account security.
    </p>
    <p>
      CMS will not share your mobile number with third parties without your
      consent, except as required by law.
    </p>
    <p>For more information on data protection, review our Privacy Policy.</p>
    <strong>Changes to Terms and Conditions</strong>
    <p>
      CMS reserves the right to modify these terms and conditions at any time.
      Changes will be communicated through appropriate channels, and continued
      use of the service constitutes the acceptance of the modified terms.
    </p>
    <strong>Termination of Service</strong>
    <p>
      • CMS may terminate or suspend access to SMS and Voice MFA without notice
      if misuse or fraudulent activity is suspected, or you violate these terms
      and conditions.
    </p>
    <strong>Contact Information</strong>
    <p>
      For questions or concerns about these terms and conditions, contact your
      Tier 1 Help Desk.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="c()">Close</button>
  </div>
</ng-template>

<ng-template #privacyPolicy let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modalTitle">
      IDM SMS & Voice Authentication and Privacy Statement
    </h4>
    <strong>Effective Date: 1/29/2025</strong>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d()"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      At the Centers for Medicare & Medicaid Services (CMS), protecting your
      privacy is one of our highest priorities. We are committed to safeguarding
      the confidentiality, integrity, and availability of the personal
      information you provide when registering with the Identity Management
      (IDM) system. This statement explains how CMS collects, uses, and protects
      your personal information when you use our SMS and Voice Multifactor
      Authentication (MFA) services.
    </p>
    <p>
      For additional details on how CMS handles your personal information,
      please refer to the CMS Privacy Act Statement.
    </p>
    <strong>Personal Information Collected</strong>
    <p>
      CMS collects only the information necessary to provide secure
      authentication services. Personal information (PII) is defined as data
      unique to an individual, such as name, address, telephone number, Social
      Security Number (SSN), and date of birth (DOB).
    </p>
    <p>
      Information we may collect when you use our SMS and Voice MFA services
      includes:
    </p>
    <p>
      • Phone Number: Your phone number is collected to send MFA verification
      codes via SMS or voice calls.
    </p>
    <p>
      • Usage Data: We may gather data on how you interact with our MFA
      services, including time stamps, authentication attempts.
    </p>
    <strong>How We Use Your Information</strong>
    <p>
      • Identity Verification: Your phone number is used solely to deliver MFA
      codes for identity verification purposes.
    </p>
    <p>
      • Service Improvement and Security: Usage data enables CMS to monitor,
      analyze, and improve the performance and security of our MFA services.
    </p>
    <strong>Sharing Your Information</strong>
    <p>CMS shares your information only under the following circumstances:</p>
    <p>
      • Third-Party Service Providers: CMS partners with external service
      providers to deliver SMS and voice MFA services. These providers are
      contractually obligated to protect your information in accordance with
      federal laws, including the Privacy Act of 1974 and the Federal
      Information Security Modernization Act (FISMA).
    </p>
    <p>
      • Legal Compliance: CMS may disclose your information in response to valid
      legal requests, subpoenas, or as required by federal law.
    </p>
    <strong>Data Security</strong>
    <p>
      CMS employs robust, industry-standard security measures to protectyour
      personal information from unauthorized access, alteration, disclosure, or
      destruction. These measures include but are not limited to:
    </p>
    <p>
      • Access Controls: Access to your personal information is restricted to
      authorized personnel with a need-to-know basis.
    </p>
    <p>
      • Regular Audits: CMS conducts regular security assessments and audits to
      ensure the integrity and security of our systems.
    </p>
    <strong>Your Rights</strong>
    <p>As a user of IDM and CMS services, you have the following rights:</p>
    <p>
      • Access and Correction: You may request access to the personal
      information CMS has collected about you and make corrections if necessary.
    </p>
    <p>
      • Opt-Out Option: You have the right to opt out of using SMS and Voice MFA
      by updating your account settings.
    </p>
    <strong>Changes to This Privacy Statement</strong>
    <p>
      CMS may update this Privacy Statement to reflect changes in technology,
      legal requirements, or service enhancements. Any significant updates will
      be communicated through appropriate channels, and the revised statement
      will include an updated "Effective Date."
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="c()">Close</button>
  </div>
</ng-template>
